import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, DollarSign, Clock, MessageSquareX } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
export function PainSection() {
  const pains = [{
    icon: DollarSign,
    title: 'Pérdida Directa',
    text: 'Pagaste por el lead. Pagaste la gasolina. Tu equipo espera. Perdiste entre $200 y $2,000 USD en una hora.'
  }, {
    icon: MessageSquareX,
    title: 'Nadie Contesta',
    text: 'Las llamadas de confirmación ya no funcionan. El 90% prefiere WhatsApp, pero no responden al teléfono.'
  }, {
    icon: Clock,
    title: 'Esclavitud Manual',
    text: 'No tienes tiempo para estar chateando todo el día persiguiendo clientes para que confirmen.'
  }];
  return <section className="py-24 bg-[#0f1629] relative" data-id="element-125">
      <div className="container mx-auto px-4" data-id="element-126">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-127">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 text-red-500 font-bold mb-4" data-id="element-128">
            <AlertTriangle className="h-5 w-5" data-id="element-129" />
            EL DOLOR DEL "NO-SHOW"
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-130">
            Si tienes un negocio de servicios en USA, sabes que un "No-Show" es
            un <span className="text-red-500" data-id="element-131">crimen financiero</span>.
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-132">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1 + 0.2
        }} data-id="element-133">
              <Card className="h-full border-red-900/30 bg-red-950/10 hover:bg-red-950/20 transition-colors" data-id="element-134">
                <CardContent className="pt-8 text-center" data-id="element-135">
                  <div className="mx-auto w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center mb-6" data-id="element-136">
                    <pain.icon className="h-8 w-8 text-red-500" data-id="element-137" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4" data-id="element-138">
                    {pain.title}
                  </h3>
                  <p className="text-slate-400 leading-relaxed" data-id="element-139">{pain.text}</p>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}